import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Statistic2ReportViewComponent } from './statistic2-report-view/statistic2-report-view.component';
import { MatDialogModule } from '@angular/material/dialog';
import { Statistic2ReportViewListComponent } from './statistic2-report-view-list/statistic2-report-view-list.component';
import { ItemsListModule } from '@fi-app/components/items-list/items-list.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { Statistic2ReportValueHeaderComponent } from './statistic2-report-value-header/statistic2-report-value-header.component';
import { InfoIconModule } from '@fi-app/shared/info-icon/info-icon.module';
import { ButtonBackModule } from '@fi-app/utilities/button-back/button-back.module';
import { FicAppTextModule } from '../../../../app-cordova/app/fic-utilities/fic-app-text/fic-app-text.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { FiPrintDownloadModule } from '@fi-shared/fi-print-download/fi-print-download.module';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatTableModule } from '@angular/material/table';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { MatSortModule } from '@angular/material/sort';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatIconModule,
        MatSelectModule,
        MatButtonModule,
        ItemsListModule,
        FiAppTextSharedModule,
        InfoIconModule,
        ButtonBackModule,
        FiPrintDownloadModule,
        FicAppTextModule,
        FiPageHeaderModule,
        FiPageHeaderButtonGroupModule,
        FiWrapperTableModule,
        MatTableModule,
        FiProfileIconModule,
        MatSortModule,
        FiWhenScrolledModule,
        FiFormatDateModule,
    ],
    declarations: [
        Statistic2ReportViewComponent,
        Statistic2ReportViewListComponent,
        Statistic2ReportViewComponent,
        Statistic2ReportValueHeaderComponent,
    ],
})
export class Statistic2ReportViewModule {}
